import { ElementRef, OnInit } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { find } from 'lodash';
/**
 * @deprecated please use <ml-chips-autocomplete> instead
 */
var ChipInputComponent = /** @class */ (function () {
    function ChipInputComponent() {
        this.separatorKeysCodes = [ENTER, COMMA];
        this.valueControl = new FormControl();
        this.displayFn = function (item) { return item.name; };
    }
    Object.defineProperty(ChipInputComponent.prototype, "values", {
        set: function (values) {
            var _this = this;
            if (values) {
                if (this.valuesControl) {
                    this.allValues = values.filter(function (value) {
                        return !find(_this.valuesControl.value, function (_value) { return _value.id === value.id; });
                    });
                }
                else {
                    this.allValues = values.slice();
                }
            }
            else {
                this.allValues = [];
            }
            this.initFilter();
        },
        enumerable: true,
        configurable: true
    });
    ChipInputComponent.prototype.initFilter = function () {
        var _this = this;
        this.filteredValues = this.valueControl.valueChanges.pipe(startWith(null), map(function (value) {
            return value ? _this._filter(value) : _this.allValues.slice();
        }));
    };
    ChipInputComponent.prototype.ngOnInit = function () { };
    ChipInputComponent.prototype.selected = function (event) {
        var value = event.option.value;
        this.valuesControl.setValue(this.valuesControl.value.concat([value]));
        var valueIndex = this.allValues.findIndex(function (_autocompleteValue) {
            return _autocompleteValue === value;
        });
        this.allValues.splice(valueIndex, 1);
        this.permissionInput.nativeElement.value = '';
        this.valueControl.setValue(null);
    };
    ChipInputComponent.prototype.add = function (event) {
        if (!this.matAutocomplete.isOpen) {
            var input = event.input;
            var value_1 = event.value;
            if ((value_1 || '').trim()) {
                var valueIndex = this.allValues.findIndex(function (_item) { return _item.name === value_1.trim(); });
                if (valueIndex !== -1) {
                    this.valuesControl.setValue(this.valuesControl.value.concat([
                        this.allValues[valueIndex]
                    ]));
                    this.allValues.splice(valueIndex, 1);
                }
            }
            if (input) {
                input.value = '';
            }
            this.valueControl.setValue(null);
        }
    };
    ChipInputComponent.prototype.remove = function (value) {
        var index = this.valuesControl.value.indexOf(value);
        if (index >= 0) {
            this.allValues.push(value);
            this.valuesControl.value.splice(index, 1);
            this.valuesControl.setValue(this.valuesControl.value.slice());
        }
    };
    ChipInputComponent.prototype._filter = function (value) {
        var _this = this;
        if (typeof value !== 'string') {
            return;
        }
        var filterValue = value.toLowerCase();
        return this.allValues.filter(function (_value) {
            return _this.displayFn(_value)
                .toLowerCase()
                .indexOf(filterValue) >= 0;
        });
    };
    return ChipInputComponent;
}());
export { ChipInputComponent };
